module.exports = __webpack_public_path__ + "img/capa1.e122591a.webp";